import { FC, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { ArticleDiscount } from "../../models/responses/articleDiscount";
import { Col, Row, Spinner } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { getArticleDiscounts } from "../../app/services/articleDiscountService";

interface Props {}

const ArticleDiscounts: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const articleDiscounts: ArticleDiscount[] = useSelector(
    (state: RootState) =>
      state.articleDiscount.articleDiscountList || [],
  );
  const loadingArticleDiscounts = useSelector(
    (state: RootState) =>
      state.articleDiscount.isWaitingArticleDiscountGetResponse,
  );

  useEffect(() => {
    dispatch(getArticleDiscounts(instance, account));
  }, [account, accounts, dispatch, instance]);

  const openArticleDiscountHandler = (
    articleDiscount: ArticleDiscount,
  ) => {
    navigate(`/article-discounts/${articleDiscount.id}`, {
      relative: "path",
    });
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h1>Artikelrabatter</h1>
        </Col>
        <Col className="text-end">
          <Button
            className="mt-2 ms-2"
            variant="outline-primary"
            href={`/article-discounts/add`}
          >
            Lägg till <Plus />
          </Button>
        </Col>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Namn</th>
            <th>Beskrivning</th>
            <th>Art.id</th>
            <th>Rabatt %</th>
            <th>Fastpris</th>
            <th>Skapad</th>
            <th>Uppdaterad</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {articleDiscounts.map((articleDiscount) => (
            <tr
              key={articleDiscount.id}
              role="button"
              onClick={() =>
                openArticleDiscountHandler(articleDiscount)
              }
            >
              <td>{articleDiscount.name}</td>
              <td>{articleDiscount.description}</td>
              <td>{articleDiscount.externalId}</td>
              <td>{articleDiscount.discountPercentage}</td>
              <td>{articleDiscount.forcedSalesPrice ?? ""}</td>
              <td>
                {articleDiscount.createdAt
                  ? new Date(articleDiscount.createdAt).toLocaleDateString()
                  : "-"}
              </td>
              <td>
                {articleDiscount.updatedAt
                  ? new Date(articleDiscount.updatedAt).toLocaleDateString()
                  : "-"}
              </td>
              <td align="center">
                <Eye />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loadingArticleDiscounts && (
        <>
          <Row className="mb-3">
            <Col className="text-center">
              <Spinner variant="primary" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ArticleDiscounts;
